const createFilter =
  (allowedFields) =>
  (payload = {}) => {
    if (!payload || typeof payload !== "object") {
      return {};
    }

    return Object.keys(payload).reduce((filtered, key) => {
      if (allowedFields.has(key) && typeof payload[key] !== "undefined") {
        filtered[key] = payload[key];
      }
      return filtered;
    }, {});
  };

const patientFields = new Set([
  "patientId",
  "patientAccountNumber",
  "firstName",
  "lastName",
  "gender",
  "birthDate",
  "ethnicity",
  "alzheimersStatus",
  "medicalHistory",
  "medicalHistoryOther",
  "familyHistory",
  "familyHistoryOther",
  "smoking",
  "yearsSmoking",
  "drinking",
  "drinksPerWeek",
  "exercise",
  "email",
  "language",
  "mobilePhoneNumber",
  "homeAddressLine1",
  "homeAddressLine2",
  "city",
  "state",
  "zipCode",
  "irbProject",
  "consentSubjectId",
  "consentDate",
]);

const encounterFields = new Set([
  "encounterId",
  "patientId",
  "patientAccountNumber",
  "firstName",
  "lastName",
  "consentDate",
  "encounterDateTime",
  "orderingPhysician",
  "department",
  "scheduledStudyIds",
  "checkInStatus",
  "sampleCollectorName",
  "collectionLocation",
]);

export const filterPatientPayload = createFilter(patientFields);
export const filterEncounterPayload = createFilter(encounterFields);
